
<template>
    <div class="main-container">

		<importFromXLSX ref="import_from_xlsx" v-on:need_refresh="() => refresh()" :service="service"/>

		<b-navbar class="px-0">
			<b-navbar-brand>
				<div v-if="has_history" class="d-flex align-items-center" style="gap: .75rem;">

					<b-button class="transparent" @click="go_back">

						<base-icon name="arrow long_left" />

					</b-button>
					<h3>Региональные коэффициенты</h3>

				</div>
				<h3 v-else >Региональные коэффициенты</h3>
			</b-navbar-brand>

			<b-nav pills class="ml-auto justify-content-end align-items-center">
				Справочник Укрупненные нормативы цены строительства

				<!--<b-nav-item v-on:click="() => make_import()" variant="primary" title="Импорт" v-b-tooltip.hover.bottomright><b-icon-download /></b-nav-item>-->
				<!-- <b-button v-if="check_roles([ 'model' ]) && !this.$root.not_editable" v-on:click="() => refresh()" variant="outline-primary" title="Обновить" v-b-tooltip.hover.bottomright><base-icon name="refresh" /></b-button> -->

			</b-nav>
		</b-navbar>

        <b-table class="main-container_content" sticky-header :fields="fields" :items="data"/>

    </div>
</template>

<script>

import api from "../../../../api"
import importFromXLSX from "./import_from_xlsx"

export default
{
    data()
    {
        return {

			service : "cadastral_expensive",

            fields :
            [
                { key : "book", label : "Наименование сборника УНЦС", },
                { key : "year", label : "Дата сборника УНЦС", },
                { key : "zone", label : "Ценовая зона", },
                { key : "transformation_rf", label : "Коэффициент перехода от цен базового района (Московская область) к уровню цен субъектов Российской Федерации (Кпер.)", },
                { key : "transformation_first_zone", label : "Коэффициент перехода от цен первой зоны субъекта Российской Федерации к уровню цен частей территории субъектов Российской Федерации, которые определены нормативными правовыми актами высшего органа государственной власти субъекта Российской Федерации, как самостоятельные ценовые зоны (Кпер/зон)", },
				{ key : "k_reg", label : "Коэффициент, учитывающий регионально-климатические условия осуществления строительства в субъекте Российской Федерации (части территории субъекта Российской Федерации) по отношению к базовому району (Крег)", },
				// { key : "from_year_to_current", label : "Переход от даты справочника к дате оценки", },
            ],

			data : [],
        }
    },

	components :
	{
		importFromXLSX,
	},

	computed :
	{
		has_history()
		{
			return this.$router.history.current.path != this.$router.history._startLocation
			// return window.history.length > 1
		}
	},

	mounted()
	{
		this.refresh()
	},

    methods :
	{
		refresh()
		{
			api.call(this, this.service, "get_regional_coefs", {},
				response =>
				{
					this.data = response.data

					this.data.forEach(elem => { elem.k_reg = 1 })
				})
		},

		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		make_import()
		{
			this.$refs.import_from_xlsx.execute()
		},

		go_back()
		{
			api.back.go(this)
		}
    },
}

</script>

